export default __webpack_public_path__ + "img/bg_digital_platforms-243ce727491fc7c8e73253fe715d609a.jpeg";